import { tracks } from "../program/displayFragments";
import { ProgramTrackEager, TrackProductEager, ProgramEager } from "./ProgramQueries";



export default (program: ProgramEager, searchText: string): ProgramEager => {
    if(!searchText) return program;

    let filteredTracks: ProgramTrackEager[] =[];
    if(program.tracks && program.tracks.length > 0 )
        filteredTracks = program.tracks.map(track => filterItems(track, searchText))
    return {id: program.id , tracks : filteredTracks};
}

function filterItems(track: ProgramTrackEager, searchText: string): ProgramTrackEager {
    let products: TrackProductEager[] = [];

    track && track.products && track.products.forEach(product => {
        /**Checking tag condtion */
        let tagCondition = false;
        if (product && product.course) {
            product.course.tags && product.course.tags.length > 0 && product.course.tags.forEach((tag) => {
                if (tag.name.toLowerCase().includes(searchText.toLowerCase())) {
                    tagCondition = true;
                }
            })

            if (
                product &&
                product.course &&
                (
                    (
                        product.course.title &&
                        product.course.title
                            .toLowerCase()
                            .includes(searchText.toLowerCase())
                    ) ||
                    (
                        product.course.description &&
                        product.course.description
                            .toLowerCase()
                            .includes(searchText.toLowerCase())
                    ) ||
                    (
                        product.course.shortDescription &&
                        product.course.shortDescription
                            .toLowerCase()
                            .includes(searchText.toLowerCase())
                    ) ||
                    (
                        product.course.keywords &&
                        product.course.keywords
                            .toLowerCase()
                            .includes(searchText.toLowerCase())
                    ) ||
                    (
                        product.course.itemExternalId &&
                        product.course.itemExternalId
                            .toLowerCase()
                            .includes(searchText.toLowerCase())
                    ) ||
                    tagCondition
                )
            ) {
                products.push(product);
            }
        }
    });

    return {...track, products: products};
}


// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/overview/ProgramFliter.ts